/**
 * Generato automaticamente.
 * framework-monitoraggio-eventi
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { GetTipoEventoParams, TipoEventoDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Cerca uno o più ruoli utente
 * @summary Cerca ruoli utente
 */
export const getTipoEvento = (
  params?: GetTipoEventoParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoEventoDTO[]>(
    {
      url: `/framework-monitoraggio-eventi/tipo-evento`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipoEventoQueryKey = (params?: GetTipoEventoParams) =>
  [
    `/framework-monitoraggio-eventi/tipo-evento`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipoEventoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipoEvento>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTipoEventoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipoEvento>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<Awaited<ReturnType<typeof getTipoEvento>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipoEventoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipoEvento>>> = ({
    signal,
  }) => getTipoEvento(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipoEventoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipoEvento>>
>;
export type GetTipoEventoQueryError = ErrorType<unknown>;

/**
 * @summary Cerca ruoli utente
 */
export const useGetTipoEvento = <
  TData = Awaited<ReturnType<typeof getTipoEvento>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTipoEventoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipoEvento>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipoEventoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
